import React from 'react'
import {connect} from 'react-redux';
import QRCode from 'qrcode.react';
import {arredondamentoPadrao, formatarReal} from '../../util/numberUtil';
import JsBarcode from 'jsbarcode';
import DOMPurify from 'dompurify'
import { EMPRESAS_NAO_EXIBIR_DIREITOS_DEVERES } from '../../util/constantsUtil';
import { podeImprimirBilheteAposEmbarque } from '../../security/Autorizacao';

export class PainelReciboPassagem extends React.Component {

    groupArrayOfObjects(list, key) {
        return list.reduce((rv, x) => {
            // eslint-disable-next-line no-param-reassign
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }

    exibirReservas(via) {
        const reservas = this.props.pedido.reservas.filter(r => r.situacaoReserva === 'APROVADO' &&
            (r.dataHoraEmbarque === null || podeImprimirBilheteAposEmbarque(this.props.empresaSelecionada.id)));
        const reservaPorItinerario = this.groupArrayOfObjects(reservas, 'itinerarioId');
        // eslint-disable-next-line no-restricted-syntax        
        return Object.entries(reservaPorItinerario)
        .map(it => <React.Fragment key={it[0]}>
            {this.exibirDadosRota(it[1][0], via)}
            {this.exibirPassageiros(it[1])}
        </React.Fragment>)
    }

    exibirDadosRota(reserva, via) {
        const viaAgencia = via !== 'Via do passageiro' && via !== 'Cupom de embarque' && via !== 'Via do Comprador';
        return <React.Fragment>
            {reserva.idRemarcada ?
                <tr className="top">
                    <td><b>**REMARCAÇÃO</b></td>
                </tr> : null
            }
            {viaAgencia ?
            <tr className="top">
                <td colSpan="3">Nome fantasia: {this.props.pedido.nomeFantasiaEmpresa}</td>
            </tr> : null}
            <tr>
                <td colSpan="3">Pedido: {this.props.pedido.id}</td>
            </tr>
            {viaAgencia ?
            <tr>
                <td colSpan="3">Número da rota: {reserva.rotaId}</td>
            </tr> : null}
            {viaAgencia ?
            <tr>
                <td colSpan="3">Número do itinerário: {reserva.itinerarioId}</td>
            </tr> : null}
            <tr>
                <td colSpan="3">Rota: {reserva.rota}</td>
            </tr>
            <tr>
                <td colSpan="3">Prefixo: {reserva.prefixoRota ? reserva.prefixoRota : 'Não informado'}</td>
            </tr>
            <tr>
                <td colSpan="3">Origem: {reserva.descCidadeOrigemAlternativa ? reserva.descCidadeOrigemAlternativa : reserva.descCidadeOrigem}</td>
            </tr>
            <tr>
                <td colSpan="3">Destino: {reserva.descCidadeDestinoAlternativa ? reserva.descCidadeDestinoAlternativa : reserva.descCidadeDestino}</td>
            </tr>
            <tr>
                <td colSpan="3">Data/Hora embarque: {reserva.dataHoraPartida}</td>
            </tr>
            <tr>
                <td colSpan="3">Tipo de
                    Viagem: {this.props.empresaSelecionada.grupo && ['BUSER', 'TCB', 'CIDAO'].includes(this.props.empresaSelecionada.grupo) ? `Convencional/${reserva.descricaoTipoPreco}` : reserva.descricaoTipoPreco}</td>
            </tr>
            {viaAgencia ?
            <tr>
                <td colSpan="3">Veículo: {reserva.nomeVeiculo}</td>
            </tr> : null}
            {viaAgencia ?
            <tr>
                <td colSpan="3">Prestador: {reserva.nomePrestador ? reserva.nomePrestador : 'Frota própria'}</td>
            </tr> : null}
            <tr className="sup">
                <td colSpan="3" align="left">
                    <b>Plataforma embarque: </b>{reserva.plataformaEmbarque ? reserva.plataformaEmbarque : '' }
                </td>
            </tr>
            <tr className="sup">
                <td colSpan="3" align="left">
                    <b>Local de embarque: </b>{reserva.embarque ? reserva.embarque : '' }
                </td>
            </tr>
        </React.Fragment>
    }

    exibirPassageiros(reservas) {
        return reservas.map(it => this.exibirPassageiro(it))
    }

    exibirPassageiro(reserva, exibeCrianca, via) {
        return <React.Fragment key={reserva.passageiroDto.id}>
            <tr className="top">
                <td colSpan="3">Número do bilhete: {reserva.id}</td>
            </tr>
            <tr>
                <td colSpan="3">Passageiro: {reserva.passageiroDto.nome}</td>
            </tr>
            <tr>
                <td colSpan="3">Poltrona: {reserva.numeroPoltrona}</td>
            </tr>
            <tr>
                <td colSpan="3">Tipo emissão: {reserva.passageiroDto.descTipoEmissao}</td>
            </tr>
            {via !== 'Via do passageiro' || (reserva.passageiroDto.tipoDocumento !== 'PASSAPORTE' && reserva.passageiroDto.tipoDocumento !== 'OUTROS') ?
            <tr>
                <td colSpan="3">CPF: {reserva.passageiroDto.cpfPassageiro}</td>
            </tr> : null}
            <tr>
                <td colSpan="3">Doc. embarque: {reserva.passageiroDto.documentoComFoto}</td>
            </tr>
            {!exibeCrianca
                ? this.exibirDadosCrianca(reserva.passageiroDto) : null}
        </React.Fragment>
    }

    seCompradorPassageiro() {
        return this.props.pedido.reservas.filter(it => it.passageiroDto.cpfPassageiro === this.props.pedido.cpfCnpjComprador).length > 0
    }

    exibirCriacaColo(passageiro) {
        if (passageiro.criancaDto) {
            return <React.Fragment>
                {this.exibirDadosCrianca(passageiro)}
                <tr align="center">
                    <td colSpan="3">
                        <QRCode style={{
                            width: 80,
                            height: 80
                        }}
                                value={`${passageiro.criancaDto.id}`}/>
                    </td>
                </tr>
            </React.Fragment>
        }
        return null
    }

    exibirDadosCrianca(passageiro) {
        const crianca = passageiro.criancaDto;
        if (crianca) {
            return <React.Fragment>
                <tr className='top'>
                    <td colSpan="3">Criança de colo: {crianca.nome}</td>
                </tr>
                <tr>
                    <td colSpan="3">Poltrona: {passageiro.numeroPoltrona}</td>
                </tr>
                <tr>
                    <td colSpan="3">Data nascimento criança: {crianca.dtNascimentoCrianca}</td>
                </tr>
                <tr>
                    <td colSpan="3">Doc. embarque criança: {crianca.documentoCriacaComFoto}</td>
                </tr>
                {crianca.cpfCrianca
                    ? <tr>
                        <td colSpan="3">CPF criança: {crianca.cpfCrianca}</td>
                    </tr> : null}
            </React.Fragment>
        }
    }

    recuperarTaxaEmbarque() {
        const reservas = this.props.pedido.reservas.filter(t => t.taxaEmbarque);
        let valor = '0';
        if (reservas.length) {
            valor = reservas
                .map(v => v.taxaEmbarque)
                .reduce((sum, current) => Number(sum) + Number(current));
        }
        return formatarReal(valor.toString())
    }

    recuperarTotalEmPedario() {
        const reservas = this.props.pedido.reservas.filter(t => t.pedagio);
        let valor = '0';
        if (reservas.length) {
            valor = reservas
                .map(v => v.pedagio)
                .reduce((sum, current) => Number(sum) + Number(current));
        }
        return formatarReal(valor.toString())
    }

    recuperarTotalTarifaSeguro() {
        const reservas = this.props.pedido.reservas.filter(reserva => reserva.tarifaSeguro);
        let valor = '0';
        if (reservas.length) {
            valor = reservas
                .map(v => v.tarifaSeguro)
                .reduce((sum, current) => Number(sum) + Number(current));
        }
        return formatarReal(valor.toString())
    }

    recuperarTotalTarifaSeguroCancelado() {
        const reservas = this.props.pedido.reservas.filter(reserva => reserva.tarifaSeguro && reserva.temEstornoSeguro);
        let valor = '0';
        if (reservas.length) {
            valor = reservas
                .map(v => v.tarifaSeguro)
                .reduce((sum, current) => Number(sum) + Number(current));
        }
        return Number(valor)
    }

    recuperarTotalGeral() {
        const reservas = this.props.pedido.reservas.filter(reserva => reserva.tarifaSeguro && reserva.temEstornoSeguro);
        let valor = '0';
        if (reservas.length) {
            // eslint-disable-next-line no-unused-vars
            valor = reservas
                .map(v => v.tarifaSeguro)
                .reduce((sum, current) => Number(sum) + Number(current));
        }
        return formatarReal((this.recuperarTotalTarifaSeguroCancelado()+this.props.pedido.valor).toString())
    }


    recuperarTaxaServico() {
        const reservas = this.props.pedido.reservas.filter(t => t.taxaServico);
        let valor = '0';
        if (reservas.length) {
            valor = reservas
                .map(v => v.taxaServico)
                .reduce((sum, current) => Number(sum) + Number(current));
        }
        return formatarReal(valor.toString())
    }

    recuperarTarifa() {
        const valor = this.props.pedido.reservas
            .map(v => v.valor)
            .reduce((sum, current) => Number(sum) + Number(current));
        return formatarReal(valor.toString())
    }

    exibirPagamentos() {
        const dinheiro = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Dinheiro').length;
        const cartao = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Cartão').length;
        const pix = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'PIX').length;
        if (dinheiro || cartao || pix) {
            return (
                <React.Fragment>
                    <tr className="sup ttu p--0">
                        <td colSpan="3">
                            <b>Pagamentos</b>
                        </td>
                    </tr>
                    {this.exibirPagamentoCartao()}
                    {this.exibirPagamentoPix()}
                    {this.exibirPagamentoDinheiro()}
                </React.Fragment>
            )
        }
        return null
    }

    exibirPagamentoCartao() {
        const pagamento = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Cartão');
        if (pagamento.length) {
            return <React.Fragment>
                <tr className="ttu">
                    <td colSpan="2">Cartão</td>
                    <td align="right">{formatarReal(pagamento[0].valor.toString())}</td>
                </tr>
                <tr className="ttu">
                    <td colSpan="2">Qtd. Parcelas</td>
                    <td align="right">{pagamento[0].quantidadeParcelas ? pagamento[0].quantidadeParcelas : 1}</td>
                </tr>
                <tr className="ttu">
                    <td colSpan="2">Número do comprovante</td>
                    <td align="right">{pagamento[0].numeroComprovante ? pagamento[0].numeroComprovante : '-'}</td>
                </tr>
            </React.Fragment>
        }
    }

    exibirPagamentoPix() {
        const pagamento = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'PIX');
        if (pagamento.length) {
            return <React.Fragment>
                <tr className="ttu">
                    <td colSpan="2">PIX</td>
                    <td align="right">{formatarReal(pagamento[0].valor.toString())}</td>
                </tr>
                <tr className="ttu">
                    <td colSpan="2">Número do comprovante</td>
                    <td align="right">{pagamento[0].numeroComprovante ? pagamento[0].numeroComprovante : '-'}</td>
                </tr>
            </React.Fragment>
        }
    }

    exibirPagamentoDinheiro() {
        const pagamento = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Dinheiro');
        if (pagamento.length) {
            return <React.Fragment>
                <tr className="ttu">
                    <td colSpan="2">Dinheiro</td>
                    <td align="right">{formatarReal(pagamento[0].valor.toString())}</td>
                </tr>
                {this.exibirDetalhesCancelamentoSeguro(this.props.pedido.valor)}
            </React.Fragment>
        }
    }

    exibirBotaoImprimir() {
        return (
            <React.Fragment>
                <a target="_BLANK" style={{cursor: 'pointer'}} data-toggle="modal"
                   data-target="#modalImpressaoReciboPassageiro" className="btn btn-laranja">
                    <i className="material-icons mr-1" style={{
                        fontSize: '18px',
                        verticalAlign: 'middle'
                    }}>
                        &#xe8ad;
                    </i>
                    Imprimir
                </a>
            </React.Fragment>)
    }

    exibirCabecalho(label, nome, cpf, nomeEmpresa, cnpj, endereco, inscricaoEstadual, tipoDocumento, numDocumento) {
        return <React.Fragment>
            <tr>
                <th className="title" colSpan="3">
                    {nomeEmpresa ? nomeEmpresa : this.props.empresaSelecionada.nome}
                    <br/>
                    <strong>CNPJ: </strong><span>{cnpj ? cnpj : this.props.empresaSelecionada.cnpj}</span> <br/>
                    {inscricaoEstadual ? <strong>IE: {inscricaoEstadual}</strong> : ''}
                    {/* eslint-disable-next-line no-undef */}
                    {_.isNil(endereco) ? null :
                        <span className='text-center'>{`
            ${endereco.logradouro ? endereco.logradouro : this.props.empresaSelecionada.endereco.logradouro + ','}
            ${endereco.numero ? endereco.numero : this.props.empresaSelecionada.endereco.numero}
            ${endereco.complemento ? `, ${endereco.complemento}` : `${this.props.empresaSelecionada.endereco.complemento}`}`}
                            {`
             ${endereco.bairro ? endereco.bairro : this.props.empresaSelecionada.endereco.bairro}
             ${endereco.localidade ? '-' + endereco.localidade : this.props.empresaSelecionada.endereco.localidade}
             ${endereco.uf ? '-' + endereco.uf : this.props.empresaSelecionada.endereco.uf}
             `}
                            ,<strong> CEP:</strong>{endereco.cep ? endereco.cep : this.props.empresaSelecionada.endereco.cep}
            </span>
                    }
                </th>
            </tr>
            <tr>
                <th colSpan="3">{this.props.pedido.data}</th>
            </tr>
            <tr>
                <th colSpan="3">
                    {nome} <br/>
                    {label == 'Via do passageiro' && (tipoDocumento == 'PASSAPORTE' || tipoDocumento == 'OUTROS') ? numDocumento : cpf}
                </th>
            </tr>
            <tr>
                <th className="ttu" colSpan="3">
                    <b>{label}</b>
                </th>
            </tr>
        </React.Fragment>
    }

    exibirCabecalhoSeguro() {
        return <React.Fragment>
            <tr>
                <th className="title mb-2" colSpan="3">
                    MBM SEGURADORA S/A
                    <br/>
                    <tr>
                        <th></th>
                    </tr>
                    <tr align='left'>
                        <strong>CNPJ: </strong>87.883.807/0001-06
                    </tr>
                    <tr align='left'>CÓD. SUSEP: 06084</tr>
                    <tr className="ttu">
                        <td align="left">R. dos Andradas, 772, Porto Alegre, RS, 90020-004</td>
                    </tr>
                    <tr className="ttu">
                        <td align="left">Processo SUSEP: 10.004808/99-14</td>
                    </tr>
                    <th></th>
                    <span>
                        <tr align='left'>SEGURO DE VIDA E FUNERAL FACULTATIVO</tr>
                        <tr align='left'> Processo SUSEP 10.004809/99-87 (Vida), 15414.901295_2016-14 (Funeral)</tr>
                        <tr align='left'>Atendimento: 0800 021 8484 www.susep.gov.br/menu/consulta-de-produtos-1</tr>
                        <tr align='left'>Estipulante: TRANSPORTE COLETIVO BRASIL LTDA</tr>
                        <tr align='left'>CNPJ: 05.376.934/0001-46</tr>
                        <th></th>
                    </span>
                    <span>
                        <tr align='left'>Corretor: RESOLUSEG ADMINISTRADORA E CORRETORA DE SEGUROS LTDA</tr>
                        <tr align='left'>CNPJ: 28.625.032/0001-00, SUSEP: 20.2070859</tr>
                    </span>
                </th>
            </tr>
        </React.Fragment>
    }

    exibirViaAgencia() {
        return <div ref={this.props.referencias.get('AGENCIA').referencia}>
            {this.exibirLimiteCupom()}
            <table className="printer-ticket">
                <thead>
                {this.exibirCabecalho('Via da Agência', this.props.pedido.nomeComprador, this.props.pedido.cpfCnpjComprador)}
                </thead>
                <tbody>
                {this.exibirReservas()}
                </tbody>
                {this.exibirTotais(false, true)}
            </table>
        </div>
    }
   
    exibirQrCodeVexado(reserva, via, index, contarQRCode = true) {
        if (via === 'Cupom de embarque') {
            return <React.Fragment>
                <tr align="center">
                    <td colSpan="3">
                        <QRCode style={{
                            width: 160,
                            height: 160
                        }}
                                value={reserva.codigoQrcodeEmbarqueMonitrip}/>
                    </td>
                </tr>
                {!reserva.numeroBilheteRodoviaria ? <>
                    {contarQRCode ? <> <tr>
                        <td colSpan="3" align="center">
                            <b>Passagem: </b>{`${index + 1}/${this.props.pedido.reservas.length}`}
                        </td>
                    </tr>
                 </>: null}
                </>: null}
            </React.Fragment>
        }

    }


    exibirBarcodeVexado(codigo, via, index) {

        if (via === 'Cupom de embarque') {
            return <React.Fragment>
                <tr align='center'>
                    <td colSpan='3'>
                        <img className='barcode'
                            data-format='EAN13'
                            data-value={codigo}
                            data-textmargin='0'
                            data-marginLeft='80'
                            data-marginRight='100'
                            />
                    </td>
                </tr>
                <tr>
                    <td colSpan="3" align="center">
                        <b>Passagem: </b>{`${index + 1}/${this.props.pedido.reservas.length}`}
                    </td>
                </tr>

            </React.Fragment>
        }

    }



    calculatValorMQC(tarifaSeguro){
        return tarifaSeguro * 0.67


    }

    calculatValorDMHO(tarifaSeguro){
        return tarifaSeguro * 0.13


    }
    exibirCupomSeguro() {
        return <React.Fragment>            
            <tr>
                <td>
                    <strong>Seguro Trajeto Facultativo</strong>
                </td>
            </tr>
            <tr><th/></tr>
            <tr>
                <td>
                    Vigência: Se inicia no momento do embarque do<br/> passageiro no veículo e termina com o desembarque<br/> definitivo do passageiro do veículo.                    
                </td>
            </tr>
            <tr>
                <td>Corretora: B3 Benefícios Ltda – CNPJ 42.703.555/0001-40.</td>
            </tr>
            <tr>
                <td>Seguradora: Universal Assistance – CNPJ 07.139.957/0001-62.</td>
            </tr>
            <tr>
                <th></th>
            </tr>
            <tr>                
                <td>
                    Coberturas – Limites de Capital:<br/>
                    * DMHO: R$ 15.000,00 <br/>
                    * Bagagem: R$ 1.000,00 <br/>
                    * Danos à Mala: R$ 800,00 
                </td>
            </tr> 
            <tr>
                <td>
                    Em caso de sinistro, o passageiro deverá entrar em contato<br/>diretamente com a seguradora e informar o CPF do segurado<br/>para abertura do atendimento:
                </td>
            </tr>
            <tr>
                <td>Telefone: 0800 555 6651</td>                
            </tr> 
            <tr>
                <span>
                    <td>E-mail: assistencias@universal-assistance.com</td>
                </span>
            </tr>
            <tr>
                <td>Seguro opcional, não integrante da tarifa de transporte 
                    <br/>e não compondo a base de cálculo do ICMS</td>
            </tr>
             <tr>
                <th></th>
            </tr>   
            <tr>
                <td>
                    <strong>Condições gerais de contratação</strong><br />
                    O seguro é elegível para passageiros até 85 anos de idade,
                    <br/>conforme regra da seguradora.
                    <br/>Os viajantes sem data de nascimento cadastrada devem
                    <br/>seguir as regras de contratação do seguro.    
                </td>    
            </tr>                
            <tr>
                <td>
                    As condições gerais do seguro podem ser encontradas em:
                </td>
             </tr>
             <tr>
                <td><a href="https://www.universal-assistance.com/br-pt/condicoes-gerais">www.universal-assistance.com/br-pt/condicoes-gerais</a></td>
             </tr>
             <tr>
                <td>A comercialização de seguro é fiscalizada pela SUSEP (www.susep.gov.br)</td>
             </tr>
             <tr>
                <td>fone: 0800-021-8484</td>
             </tr>
            {this.exibirLimiteCupom()}
            {this.linha()}
        </React.Fragment>
    }
    exibirCupomSeguroAntigo(via, reserva) {
        return <div>
            <table className="printer-ticket">
                <thead>
                {this.exibirCabecalhoSeguro()}
                </thead>
                <tbody>
                <tr>
                    <td colSpan='3'>Apólice: 10.0993.54782.001</td>
                </tr>
                <tr>
                    <td colSpan='3'>Proposta: 0672/2022</td>
                </tr>
                <tr align='left'>
                    <td colSpan='3'>Certificado individual: MBM-{reserva.numeroSeguro? reserva.numeroSeguro.replace(/^(\d{4})(\d{6})(\d{1}).*/, '$1-$2-$3') : 'MBM-0000-000000-0'}</td>
                </tr>
                <tr>
                    <td colSpan='3'>Bilhete de viagem: {reserva.id}</td>
                </tr>
                <tr align='left'>
                    <td colSpan='3'>Origem / Destino: {reserva.rota}</td>
                </tr>
                <tr>
                    <td colSpan='3'>Data Adesão: {reserva.dataVenda}</td>
                </tr>
                <tr align='left'>
                    <td colSpan='3'>Data da Viagem: {reserva.dataHoraPartida}</td>
                </tr>
                <tr align='left'>
                    <td colSpan='3'>Vigência : {reserva.dataHoraChegada}</td>
                </tr>
                <tr align='left'>
                    <td colSpan='3' style={{ color: 'darkgoldenrod'}}>** Vigência: Se inicia no momento do embarque do passageiro no veículo e termina com o desembarque definitivo do passageiro do veículo.</td>
                </tr>

                <tr align='left'>
                    <td colSpan='3'>Beneficiário: Conforme legislação vigente.</td>
                </tr>
                <tr><th/></tr>

                <tr align='left'>
                    <td colSpan='3'>Nome do passageiro: {reserva.passageiroDto.nome}</td>
                </tr>
                <tr align='left'>
                    <td colSpan='3'>CPF/RG/RNE: {this.incluirMascaraCpfPassageiro(reserva.passageiroDto.cpfPassageiro)}</td>
                </tr>

                <tr><th/></tr>

                <tr align='left'>
                    <td colSpan='3'>GARANTIAS E CAPITAIS SEGURADOS</td>
                </tr>
                <tr align='left'>
                    <td colSpan='3'>1) Morte qualquer causa (MQC): R$ 5.000,00</td>
                </tr>

                <tr align='left'>
                    <td colSpan='3'>2) Invalidez permanente total ou parcial por
                        acidente (IPA): até R$ 5.000,00</td>
                </tr>
                <tr align='left'>
                    <td colSpan='3'> 3) Despesas Medico-Hospitalares e Odontológicas
                        por acidente (DMHO): até R$ 250,00</td>
                </tr>
                <tr align='left'>
                    <td colSpan='3'>4) Seguro funeral (SFMA): até R$ 5.000,00</td>
                </tr>
                <tr align='left'>
                    <td colSpan='3'>Valor do Premio por Cobertura:</td>
                </tr>
                <tr align='left'>
                    <td colSpan='3'>MQC = {arredondamentoPadrao(this.calculatValorMQC(reserva.tarifaSeguro)).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL'
                    })}</td>
                </tr>
                <tr align='left'>
                    <td colSpan='3'>DMHO = {arredondamentoPadrao(this.calculatValorDMHO(reserva.tarifaSeguro)).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL'
                    })}</td>
                </tr>
                <tr align='left'>
                    <td colSpan='3'>  Valor do seguro: {formatarReal(reserva.tarifaSeguro).toString()}</td>
                </tr>
                <th/>
                <tr align='left'>
                    <td colSpan='3'>EM CASO DE SINISTRO LIGUE: 0800 541 2555</td>
                </tr>
                <tr align='left'>
                    <td colSpan='3'>SAC: 0800 541 2555</td>
                </tr>
                <tr>
                    <td colSpan='3'>Deficiente Auditivo/Fala: 0800 201 1838</td>
                </tr>
                <tr align='left'>
                    <td colSpan='3'>Serviço de Assistência Funeral 0800 603 28255</td>
                </tr>
                <th/>
                <tr align='left'>
                    <td colSpan='3'><strong>CONDIÇÕES GERAIS</strong></td>
                </tr>
                <tr align='left'>
                    <td colSpan='3'> Saiba mais acessando as condições especiais e
                        gerais em www.mbmseguros.com.br</td>
                </tr>
                <th/>
                <tr align='left'>
                    <td colSpan='3'>Chancelado por: Paulo Fernando Hendges
                        Diretor Presidente</td>
                </tr>
                <tr><td>Boa Viagem!</td></tr>
                </tbody>
                <tfoot>
                </tfoot>
            </table>
            {this.exibirLimiteCupom()}
            {this.linha()}
        </div>
    }

    incluirMascaraCpfPassageiro(cpf){
        if(cpf.length === 11){
            return cpf.substr(0,3)+'.***.***-'+cpf.substr(9,11)
        }
    }

    componentDidMount() {
        JsBarcode('.barcode').init();
    }

    exibirCupom(via, reserva, index, crianca) {
        return <div>
            {this.exibirLimiteCupom()}
            <table className="printer-ticket">
                <thead>
                {!crianca ? this.exibirCabecalho(via, reserva.passageiroDto.nome, reserva.passageiroDto.cpfPassageiro, reserva.nomeEmpresa, reserva.cnpjEmpresa, reserva.endereco, reserva.inscricaoEstadual,
                    reserva.passageiroDto.tipoDocumento, reserva.passageiroDto.documentoComFoto)
                    : this.exibirCabecalho(via, reserva.passageiroDto.criancaDto.nome, reserva.passageiroDto.criancaDto.cpfCrianca)}
                </thead>
                <tbody>
                {this.exibirQrCodeVexado(reserva, via, index)}
                {reserva.numeroBilheteRodoviaria ? this.exibirBarcodeVexado(reserva.numeroBilheteRodoviaria, via, index) : null}
                {this.exibirDadosRota(reserva, via)}
                {!crianca ? this.exibirPassageiro(reserva, true, via) : this.exibirCriacaColo(reserva.passageiroDto)}
                </tbody>
                <tfoot>
                {this.exibirTotaisReserva(reserva, crianca)}
                {this.exibirVendedor()}
                {via !== 'Via do passageiro' ? this.exibirDelimitacao() : null}
                {via !== 'Via do passageiro' && via !== 'Cupom de embarque' ? this.exibirCamposItinerario(reserva) : null}
                {this.exibirBpe(reserva, via)}
                {this.exibirMensagemAviso()}
                </tfoot>
            </table>
            {this.exibirLimiteCupom()}
            {this.linha()}
        </div>
    }

    exibirBilheteEmbarque(via, reserva) {
        return (
            <div>
                {this.exibirLimiteCupom()}
                <table className="printer-ticket">
                    <thead>
                        {this.exibirCabecalhoBilheteEmbarque(via, reserva)}
                    </thead>
                    <tbody>
                        <tr>
                            <td colSpan="3">Empresa: {reserva.nomeEmpresa} - {this.props.pedido.data}</td>
                        </tr>
                        <tr>
                            <td  colSpan="3">Origem: {reserva.descCidadeOrigemAlternativa ? reserva.descCidadeOrigemAlternativa : reserva.descCidadeOrigem}
                            /Destino: {reserva.descCidadeDestinoAlternativa ? reserva.descCidadeDestinoAlternativa : reserva.descCidadeDestino}
                            /Bilhete: {reserva.id}</td>
                        </tr>
                        <tr>
                            <td  colSpan="3">Data/Hora Embarque: {reserva.dataHoraPartida}</td>
                        </tr>
                        <tr>
                            <td  colSpan="3">Número tarifa: {reserva.numeroTarifa} / Código tarifa: {reserva.codigoTarifa} </td>
                        </tr>
                        <tr>
                            <td colSpan="3">Valor: {formatarReal(reserva.taxaEmbarque ? reserva.taxaEmbarque.toString() : '0')}</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr align="center">
                            <td  colSpan="3" style={{marginTop: '10px'}}>
                                <QRCode style={{
                                        width: 160,
                                        height: 160
                                    }}
                                    value={reserva.numeroTarifa}
                                />
                            </td>
                        </tr>
                    </tbody>                    
                </table>
                {this.exibirLimiteCupom()}
                {this.linha()}
            </div>
        )
    }

    exibirCabecalhoBilheteEmbarque(via) {
        return (
            <>
               <tr>
                    <th colSpan="3" style={{textTransform: 'uppercase'}}>{via}</th>
                </tr>             
            </>
        )
    }

    exibirVendedor() {
        return <React.Fragment>
            <tr className="sup">
                <td colSpan="3" align="center">
                    <b>Vendedor: </b>{this.props.pedido.nomeVendedor}<br/>
                    {this.props.pedido.telefoneVendedor}
                </td>
            </tr>
        </React.Fragment>
    }

    exibirDelimitacao() {
        return <React.Fragment>
            <tr className="sup">
                <td colSpan="3" align="center">
                    <b>Delimitação: </b>{this.props.pedido.delimitacao}<br/>
                </td>
            </tr>
        </React.Fragment>
    }

    exibirCamposItinerario(reserva) {
        return <React.Fragment>

        <tr className="sup ttu p--0">
            <td colSpan="3">
                <b>Nome fantasia: {this.props.pedido.nomeFantasiaEmpresa}</b>
            </td>
        </tr>
            <tr>
                <td colSpan="3">Número da rota: {reserva.rotaId}</td>
            </tr>
            <tr>
                <td colSpan="3">Número do itinerário: {reserva.itinerarioId}</td>
            </tr>
            <tr>
                <td colSpan="3">Veículo: {reserva.nomeVeiculo}</td>
            </tr>
            <tr>
                <td colSpan="3">Prestador: {reserva.nomePrestador ? reserva.nomePrestador : 'Frota própria'}</td>
            </tr>
            <tr className="sup">
                <td colSpan="3" align="left">
                    <b>Plataforma embarque: </b>{reserva.plataformaEmbarque ? reserva.plataformaEmbarque : '' }
                </td>
            </tr>
            <tr className="sup">
                <td colSpan="3" align="left">
                    <b>Local de embarque: </b>{reserva.embarque ? reserva.embarque : '' }
                </td>
            </tr>
        </React.Fragment>
    }

    exibirBpe(reserva, via) {
        if (via === 'Cupom de embarque') {
            return null
        }
        if (reserva.transmissaoBpe) {
            return <React.Fragment>
                <tr className="sup">
                    <td colSpan="3" align="center">
                        ICMS: <span>{reserva.valorICMS ? formatarReal(reserva.valorICMS): ''}</span> {this.props.pedido.icmsDesconto ? this.props.pedido.icmsDesconto.replace('.', ',')
                        : this.props.pedido.icmsDesconto} ({`${reserva.aliquotaICMS}%`})
                        {reserva.aliquotaIBSUF ? <>IBS-UF: <span>{formatarReal(reserva.valorIBSUF)}</span> ({reserva.aliquotaIBSUF}%)<br/></> : null}
                        {reserva.aliquotaIBSMun ? <>IBS-Mun: <span>{formatarReal(reserva.valorIBSMun)}</span> ({reserva.aliquotaIBSMun}%)<br/></> : null}
                        {reserva.aliquotaCBS ? <>CBS: <span>{formatarReal(reserva.valorCBS)}</span> ({reserva.aliquotaCBS}%)<br/></> : null}
                        TRIB: {this.props.pedido.outrosDescontos ? this.props.pedido.outrosDescontos.replace('.', ',')
                        : this.props.pedido.outrosDescontos} ({this.props.pedido.outrosTributos ? this.props.pedido.outrosTributos.replace('.', ',')
                        : this.props.pedido.outrosTributos}%)
                    </td>
                </tr>
                <tr className="ttu">
                    <td colSpan="3" align="center" className="font-sm">
                        (Lei Federal 12.741/2012)
                    </td>
                </tr>
                <tr><td colSpan="3" style={{paddingTop: '4px'}}></td></tr>
                <tr className="ttu">
                    <td colSpan="3" align="center" className="font-sm" style={{wordWrap: 'break-word'}}>
                        <a target="_BLANK" href={reserva.transmissaoBpe.urlConsulta}
                           rel='noreferrer'>{reserva.transmissaoBpe.urlConsulta}</a>
                    </td>
                </tr>
                <tr className="ttu">
                    <td colSpan="3" align="center" className="font-sm">
                        {reserva.transmissaoBpe.chaveAcesso}
                    </td>
                </tr>
                {reserva.transmissaoBpe.emitidoEmContigencia ? <tr align="center">
                    <td colSpan="3">
                        <QRCode style={{
                            width: 160,
                            height: 160
                        }}
                                value={this.props.pedido.idEmpresa === 251 ? 'http://bpeemitidoemcontingencia.log.br/': `${reserva.transmissaoBpe.urlConsulta}`}/>
                    </td>
                </tr> : <tr align="center">
                    <td colSpan="3">
                        <QRCode style={{
                            width: 160,
                            height: 160
                        }}
                                value={`${reserva.transmissaoBpe.qrCod}`}/>
                    </td>
                </tr>}
                {reserva.transmissaoBpe.emitidoEmContigencia ? <tr align="center">
                    <td colSpan="3">
                        <span style={{color: 'red'}}>EMITIDO EM CONTINGÊNCIA</span>
                    </td>
                </tr> : null}
            </React.Fragment>
        }
    }

    exibirViaComprador() {
        if (!this.seCompradorPassageiro()) {
            return <React.Fragment>
                {this.linha()}
                <div ref={this.props.referencias.get('COMPRADOR').referencia}>
                    {this.exibirLimiteCupom()}
                    <table className="printer-ticket">
                        <thead>
                        {this.exibirCabecalho('Via do Comprador', this.props.pedido.nomeComprador, this.props.pedido.cpfCnpjComprador)}
                        </thead>
                        <tbody>
                        {this.exibirReservas('Via do Comprador')}
                        </tbody>
                        {this.exibirTotais(true)}
                    </table>
                    {this.exibirLimiteCupom()}
                </div>
            </React.Fragment>
        }
    }

    exibirTotais(exibirAviso, exibirTrBranca) {
        return <tfoot>
        <tr className="sup ttu p--0">
            <td colSpan="3">
                <b>Totais</b>
            </td>
        </tr>
        <tr className="ttu">
            <td colSpan="2">Tarifa</td>
            <td align="right">{this.recuperarTarifa()}</td>
        </tr>
        <tr className="ttu">
            <td colSpan="2">Pedágio</td>
            <td align="right">{this.recuperarTotalEmPedario()}</td>
        </tr>
        <tr className="ttu">
            <td colSpan="2">Tarifa seguro</td>
            <td align="right">{this.recuperarTotalTarifaSeguro()}</td>
        </tr>
        <tr className="ttu">
            <td colSpan="2">Taxa de embarque</td>
            <td align="right">{this.recuperarTaxaEmbarque()}</td>
        </tr>
        <tr className="ttu">
            <td colSpan="2">Taxa de serviço</td>
            <td align="right">{this.recuperarTaxaServico()}</td>
        </tr>
        <tr className="ttu">
            <td colSpan="2">Outros</td>
            <td align="right">R$ 0,00</td>
        </tr>
        <tr className="ttu">
            <td colSpan="2">Desconto</td>
            <td align="right">{formatarReal(this.props.pedido.valorTotalDesconto.toString())}</td>
        </tr>
        <tr className="ttu">
            <td colSpan="2">Valor total pago</td>
            <td align="right">{this.recuperarTotalGeral()}</td>
        </tr>
        {this.exibirPagamentos()}
        <tr className="sup">
            <td colSpan="3" align="center">
                <b>Vendedor: </b>{this.props.pedido.nomeVendedor}
            </td>
        </tr>
        {exibirAviso ? this.exibirMensagemAviso() : null}
        {exibirTrBranca ? this.exibirTrBranca() : null}
        </tfoot>
    }

    exibirTrBranca() {
        return <tr className="sup printer-element">
            <td colSpan="3">x
            </td>
        </tr>
    }''

    exibirDetalhesCancelamentoSeguro(valorTotal){
        return this.recuperarTotalTarifaSeguroCancelado() > 0 ?
            <React.Fragment>
                <tr className="ttu">
                    <td colSpan="2">Cancelamento seguro</td>
                    <td align="right">-{formatarReal(this.recuperarTotalTarifaSeguroCancelado().toString())}</td>
                </tr>
                <tr className="ttu">
                    <td colSpan="2">Valor total pago</td>
                    <td align="right">{formatarReal(valorTotal.toString())}</td>
                </tr>
            </React.Fragment>
            : null
    }

    somarAcrescimoPassagem(tarifa, acrescimo) {
        return Number(tarifa) + Number(acrescimo);
    }

    exibirTotaisReserva(reserva, crianca) {
        const valorTotal = Number(reserva.valorTotalReserva)-reserva.tarifaSeguro;
        return <React.Fragment>{!crianca ? <React.Fragment>
            <tr className="sup ttu p--0">
                <td colSpan="3">
                    <b>Totais</b>
                </td>
            </tr>
            <tr className="ttu">
                <td colSpan="2">Tarifa</td>
                <td align="right">{formatarReal(this.somarAcrescimoPassagem(reserva.tarifa, reserva.acrescimoPassagem).toString())}</td>
            </tr>
            <tr className="ttu">
                <td colSpan="2">Tarifa cobrada</td>
                <td align="right">{formatarReal(reserva.valor.toString())}</td>
            </tr>
            <tr className="ttu">
                <td colSpan="2">Pedágio</td>
                <td align="right">{formatarReal(reserva.pedagio ? reserva.pedagio.toString() : '0')}</td>
            </tr>
            <tr className="ttu">
                <td colSpan="2">Tarifa seguro</td>
                <td align="right">{formatarReal(reserva.tarifaSeguro ? reserva.tarifaSeguro.toString() : '0')}</td>
            </tr>
            <tr className="ttu">
                <td colSpan="2">Taxa de embarque</td>
                <td align="right">{formatarReal(reserva.taxaEmbarque ? reserva.taxaEmbarque.toString() : '0')}</td>
            </tr>
            <tr className="ttu">
                <td colSpan="2">Taxa de serviço</td>
                <td align="right">{formatarReal(reserva.taxaServico ? reserva.taxaServico.toString() : '0')}</td>
            </tr>
            <tr className="ttu">
                <td colSpan="2">Desconto</td>
                <td align="right">{reserva.desconto ? formatarReal(reserva.desconto.toString()) : formatarReal('0')}</td>
            </tr>
            <tr className="ttu">
                <td colSpan="2">Outros</td>
                <td align="right">R$ 0,00</td>
            </tr>
            <tr className="ttu">
                <td colSpan="2">Valor total</td>
                <td align="right">{formatarReal(reserva.valorTotalReserva).toString()}</td>
            </tr>

            {this.exibirDetalhesCancelamentoSeguro(valorTotal)}
            <tr className="ttu">
                <td colSpan="2">Forma de pagamento</td>
                <td align="right">{this.recuperaFormaPagamento()}</td>
            </tr>
        </React.Fragment> : null}
        </React.Fragment>

    }

    recuperaFormaPagamento() {
        const cartao = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Cartão').length > 0;
        const dinheiro = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Dinheiro').length > 0;
        const pix = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'PIX').length > 0;

        if (cartao && dinheiro && pix) {
            return 'Cartão, Dinheiro e PIX';
        }

        if (cartao && dinheiro) {
            return 'Cartão e dinheiro';
        }
        if (cartao && pix) {
            return 'Cartão e PIX';
        }
        if (dinheiro && pix) {
            return 'Dinheiro e PIX';
        }
        if (dinheiro) {
            return 'Dinheiro'
        }

        if (cartao) {
            return 'Cartão'
        }

        if (pix) {
            return 'PIX'
        }

        return 'Não informado'
    }

    exibirMensagemAviso() {
        if (this.props.empresaSelecionada?.mensagemAvisoBilhete) {
            let rawHTML = this.props.empresaSelecionada.mensagemAvisoBilhete;

            // Força todos os <a> a terem target="_blank"
            rawHTML = rawHTML.replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');

            // Corrige links que estão sem http:// ou https://
            rawHTML = rawHTML.replace(/href="(www\.[^"]+)"/g, 'href="https://$1"');

            const sanitized = DOMPurify.sanitize(rawHTML, {
                ADD_ATTR: ['target', 'rel'],
                FORCE_BODY: true
            });

            return (
                <tr className="sup">
                    <td colSpan="3">
                        <div dangerouslySetInnerHTML={{ __html: sanitized }} />
                    </td>
                </tr>
            );
        }
    }



    linha() {
        return <hr id='printPageButton' style={{
            borderStyle: 'dashed',
            borderWidth: 3
        }}/>
    }

    ehGratuidadeTotal(tipoEmissao) {
        return tipoEmissao === 'ID_JOVEM_100'
            || tipoEmissao === 'IDOSO_100'
            || tipoEmissao === 'DEFICIENTE'
            || tipoEmissao === 'P_LIVRE_POLICIAL_AUDITOR'
    }

    exibirCuponsReservas() {
        const {modoImpressaoSimplificado, empresaSelecionada} = this.props;

        const reservas = this.props.pedido.reservas.filter(r => r.situacaoReserva === 'APROVADO' &&
            (r.dataHoraEmbarque === null || podeImprimirBilheteAposEmbarque(empresaSelecionada.id)))
            .sort((a, b) => {                
                if (a.passageiroDto.cpfPassageiro === b.passageiroDto.cpfPassageiro) {                    
                    if (a.rotaId === b.rotaId) {
                        if (a.prefixoIdaVolta === b.prefixoIdaVolta) {
                            if (a.prefixoRota === b.prefixoRota) {                            
                                return a.ordemTrechoOrigem - b.ordemTrechoOrigem;
                            }                        
                            return a.prefixoRota.toLowerCase() === 'ida' || a.prefixoRota.toLowerCase() === 'volta' ? -1 
                                : a.prefixoRota.localeCompare(b.prefixoRota);
                        }                        
                        return a.prefixoIdaVolta === 'ida' ? -1 : 1;
                    }                    
                    return a.rotaId - b.rotaId;
                }
                return a.passageiroDto.cpfPassageiro.localeCompare(b.passageiroDto.cpfPassageiro);
            });
        return <React.Fragment>
            {this.linha()}
            <div ref={this.props.referencias ? this.props.referencias.get('TODOS_PASSAGEIROS').referencia : null}>
                {reservas.map((it, index) => <div key={`reserva${it.id}`}>
                    <div
                        ref={this.props.referencias ? this.props.referencias.get(`PASSAGEIRO${it.passageiroDto.id}`).referencia : null}>
                            {modoImpressaoSimplificado ? <>
                            {this.exibirCupom('Cupom de embarque', it, index)}
                         </>
                         :<>
                            <div className="pagebreak"/>
                            {this.exibirCupom('Via do passageiro', it, index)}
                            <div className="pagebreak"/>
                            {this.exibirCupom('Cupom de embarque', it, index)}                            
                            {this.exibirSeguro('Via do seguro', it, index)}
                            {it.regraBilhete == 'REGRA_W2I' && <><div className="pagebreak"/>
                            {this.exibirBilheteEmbarque('Bilhete de Embarque', it)}</>}
                        </>}
                    </div>                    
                    {it.passageiroDto.criancaDto
                        ? <div
                            ref={this.props.referencias ? this.props.referencias.get(`CRIANCA${it.passageiroDto.id}`).referencia : null}>
                            {this.exibirCupom('Via do passageiro', it, index, true)}
                            <div className="pagebreak"/>
                            {this.exibirCupom('Cupom de embarque', it, index, true)}
                        </div> : null}
                </div>)}
            </div>
        </React.Fragment>
    }

    exibirSeguro(label, reserva, index) {
        if(reserva.situacaoReserva === 'APROVADO' &&
            (reserva.dataHoraEmbarque === null || podeImprimirBilheteAposEmbarque(this.props.empresaSelecionada.id)) &&
            (reserva.tarifaSeguro !== '0.00' && reserva.numeroSeguro)){
            return <React.Fragment>
                <div className="pagebreak"/>
                {this.linha()}

                <div
                    ref={this.props.referencias ? this.props.referencias.get(`PASSAGEIRO${reserva.passageiroDto.id}`).referencia : null} className="printer-ticket">
                    {this.exibirCupomSeguro(label, reserva, index)}
                </div>
            </React.Fragment>

        }
        return ''

    }

    exibirLimiteCupom() {
        return <div className='printer-element'>--</div>
    }

    exibirDireitoDeveres() {
        if (!EMPRESAS_NAO_EXIBIR_DIREITOS_DEVERES.includes(this.props.empresaSelecionada.id)) {
            return (
                <div ref={this.props.referencias.get('DIREITOS_DEVERES').referencia}>
                    {this.linha()}
                    {this.exibirLimiteCupom()}
                    <div className="printer-ticket" style={{textAlign: 'justify', padding: '5px'}}>                    
                        <div className='direitosEdeveres'
                            dangerouslySetInnerHTML={{ __html: this.props.pedido.direitosEDeveres }}
                        />
                    </div>
                    {this.exibirLimiteCupom()}
                    {this.linha()}
                </div>
            )
        }

        return ''
    }

    getReservas() {
        return this.props.pedido.reservas.filter(r => r.situacaoReserva === 'APROVADO' &&
            (r.dataHoraEmbarque === null || podeImprimirBilheteAposEmbarque(this.props.empresaSelecionada.id)));
    }
    getTrResumoCupom(reservas) {        
        return reservas.map((reserva, index) => (
            <React.Fragment key={`resumo-cupom-${index}`}>
                <tr>
                    <td colSpan="3">Pedido: {this.props.pedido.id}</td>
                </tr>                
                <tr>
                    <td colSpan="3">Rota: {reserva.rota}</td>
                </tr>
                <tr>
                    <td colSpan="3">Prefixo: {reserva.prefixoRota ? reserva.prefixoRota : 'Não informado'}</td>
                </tr>
                <tr>
                    <td colSpan="3">Origem: {reserva.descCidadeOrigemAlternativa ? reserva.descCidadeOrigemAlternativa : reserva.descCidadeOrigem}</td>
                </tr>
                <tr>
                    <td colSpan="3">Destino: {reserva.descCidadeDestinoAlternativa ? reserva.descCidadeDestinoAlternativa : reserva.descCidadeDestino}</td>
                </tr>
                <tr>
                    <td colSpan="3">Data/Hora embarque: {reserva.dataHoraPartida}</td>
                </tr>
                <tr>
                    <td colSpan="3">Tipo de
                        Viagem: {this.props.empresaSelecionada.grupo && ['BUSER', 'TCB', 'CIDAO'].includes(this.props.empresaSelecionada.grupo) ? `Convencional/${reserva.descricaoTipoPreco}` : reserva.descricaoTipoPreco}</td>
                </tr>
                <tr>
                    <td colSpan="3">Nome: {reserva.passageiroDto.nome}</td>
                </tr>
                <tr>
                    <td colSpan="3">Doc. embarque: {reserva.passageiroDto.documentoComFoto}</td>
                </tr>
                {this.exibirQrCodeVexado(reserva, 'Cupom de embarque', index, false)}
                {reserva.passageiroDto.criancaDto ? this.exibirCriacaColo(reserva.passageiroDto) : null}
            </React.Fragment>
        ))
    }
    agrupadoPorCPFPassageiro(dados) {
        return dados.reduce((acc, item) => {
            const cpf = item.passageiroDto.cpfPassageiro;
            if (!acc[cpf]) {
            acc[cpf] = [];
            }
            acc[cpf].push(item);
            return acc;
        }, {});
    }

    parseDataHora(dataHora) {
        const [data, hora] = dataHora.split(' ');
        const [dia, mes, ano] = data.split('/').map(Number);
        const [horaPart, minutoPart] = hora.split(':').map(Number);
        return new Date(ano, mes - 1, dia, horaPart, minutoPart);
    }
    
    resumoCupom() {
        const reservas = this.getReservas();        
        const agrupadoPorCPF = this.agrupadoPorCPFPassageiro(reservas);        
        return Object.entries(agrupadoPorCPF).map(([cpf, items], index) => (
            <div
              key={`resumo-cupom-passageiro${index}`}
              ref={this.props.referencias.get(`RESUMO_CUPOM${cpf}`).referencia}>                
              <table className="printer-ticket">                
                {this.exibirCabecalho('Via do passageiro', items[0].passageiroDto.nome, items[0].passageiroDto.cpfPassageiro)}                
                {this.getTrResumoCupom(items.sort((a, b) => {                    
                    const dataA = this.parseDataHora(a.dataHoraPartida);
                    const dataB = this.parseDataHora(b.dataHoraPartida);
                    return dataA - dataB;
                }))}
              </table>              
              {this.exibirLimiteCupom()}
              {this.linha()}
              {this.exibirDireitoDeveres()}
            </div>
          ));          
    }
    
    render() {        
        return (
            <React.Fragment>
                <div className='col-md-12 d-flex justify-content-center'>
                    <div>
                        {this.props.isItinerario ? '' :
                            <React.Fragment>
                                {this.exibirViaAgencia()}
                                <div className="pagebreak"/>
                                {this.exibirViaComprador()}
                                <div className="pagebreak"/>
                                {this.exibirDireitoDeveres()}
                                <div className="pagebreak"/>
                                {this.props.referenciaSelecionada != null && this.props.referenciaSelecionada.includes('RESUMO_CUPOM') && <>{this.resumoCupom()}
                                <div className="pagebreak"/></>}
                            </React.Fragment>}
                        {this.exibirCuponsReservas()}
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada
    }
}


export default connect(mapStateToProps, {})(PainelReciboPassagem);
